export default {
  getSummary: state => state.summary,
  getCustomers: state => state.customers || [],
  getSalesManagers: state => state.salesManagers || [],
  getBidNumber: state => state.bidNumber,
  // Specifications
  getSpecificationsSite: state => state.specifications.site,
  getSpecificationsBid: state => state.specifications.bid,
  getSpecificationsCpTypes: state => state.specifications.cpTypes,
  getSpecificationsScheduleTypes: state => state.specifications.scheduleTypes,
  getSpecificationsKitTypes: state => state.specifications.kitTypes,
  // Decision
  getBidDecisionCriteriaSets: state => state.bidDecisionCriteriaSets,
  getBidDecision: state => state.bidDecision,
  getFeedback: state => state.feedback,
}
